import Reveal from '@/pages/zz-review/components/Reveal';

export default function PortalSection() {
  return (
    <section id="portal" className="w-full py-16 md:py-24 bg-background-100 scroll-mt-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <Reveal>
          <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 mb-3">Portal</p>
          <h2
            className="text-2xl md:text-4xl text-foreground-900 mb-6"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            生命實踐系統
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto mb-8">
            閱讀完成，不等於能力完成。AUM1001 Matrix 透過 RG Portal、AI Angel 與 Evidence
            成長紀錄，把閱讀延伸成可以持續實踐的生命導航系統。
          </p>
          <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500 bg-background-50 border border-background-200/70 rounded-full px-3 py-1.5 whitespace-nowrap">
            <i className="ri-loader-4-line" />
            Portal 目前為階段性建置與測試中
          </span>
        </Reveal>
      </div>
    </section>
  );
}